import '../Shared/translations.js';
import '../cart_constants.js.php';
import '../Shared/shared_constants.js.php';
import '../Shared/handlebars.js';
import '../Shared/shared_hbs_templates.js.php';
import '../Shared/global.js';
import '../cart-all.js';
import '../../../../../node_modules/lazysizes/lazysizes.min.js';
import '../Shared/Announcements/index.js';
import '../Shared/PopupModal/index.js';
import '../Product/notify_product_wrapper';
